import { Box } from "@mui/material";
import { useOutletContext } from "react-router";
import { Typography } from "@platform/design-system";

import { InvitesTable, UsersTable } from "../../../components";
import { UsersContext } from "../types";

import type { ReactElement } from "react";

const Users = (): ReactElement => {
  const { data, brokerId, queryKey } = useOutletContext<UsersContext>();

  const dataUsers = [
    {
      title: "Super Users",
      data: data.owners,
    },
    {
      title: "Users",
      data: data.members,
    },
  ];

  return (
    <Box display="flex" flexDirection="column" rowGap={4} width="100%">
      <Box>
        <Typography variant="display-small" mb={3}>
          Invites
        </Typography>
        <InvitesTable
          data={data?.invites}
          brokerId={brokerId}
          invalidateQueryKey={queryKey}
        />
      </Box>

      {dataUsers.map((item) => (
        <Box key={item.title}>
          <Typography variant="display-small" mb={3}>
            {item.title}
          </Typography>
          <UsersTable data={item.data} />
        </Box>
      ))}
    </Box>
  );
};

export { Users };
